import { ChatState } from "PFApp/components/chat/chat_states";
import { Dispatch, SetStateAction, useEffect } from "react";

type UseClearUnreadOnFetchParams = {
  isFetched: boolean;
  unreadCount: number;
  onClearNotifications: () => void;
  invalidateAllConversations: () => void;
  refetchConversation: () => void;
  setChatState: Dispatch<SetStateAction<ChatState>>;
};

// after chat window is opened and messages are fetched
// we need to clear unread notifications and refresh conversations
// because when message are fetched they are marked as read, and related conversation is upaded
export const useClearUnreadOnFetch = ({
  isFetched,
  unreadCount,
  onClearNotifications,
  invalidateAllConversations,
  refetchConversation,
  setChatState
}: UseClearUnreadOnFetchParams) => {
  useEffect(() => {
    if (!isFetched) {
      return;
    }
    if (unreadCount > 0) {
      onClearNotifications();
      invalidateAllConversations();
      refetchConversation();
    }
    setChatState(ChatState.Normal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetched]);
};
